import { render, staticRenderFns } from "./FallbackSelfies.vue?vue&type=template&id=6b6d5234&"
import script from "./FallbackSelfies.vue?vue&type=script&lang=ts&"
export * from "./FallbackSelfies.vue?vue&type=script&lang=ts&"
import style0 from "./FallbackSelfies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports